import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getSimulations(accessToken) {
  try {
    const result = await axios.get(`${BASE_API_URL}/simulacao/50000/1`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return result.data;
  } catch (error) {
    if (error.response.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      return window.location.replace("/");
    }
    return alert("Algo deu errado, tente novamente mais tarde.");
  }
}

export async function createSimulation(accessToken, data) {
  try {
    // cliente / empresa / estado / cidade / produto / volume / prazo
    localStorage.setItem(
      "simulacao",
      JSON.stringify({
        client_id: data.client_id,
        company_id: data.company_id,
        volume: data.volume,
        uf_id: data.uf_id,
        city_id: data.city_id,
        product_id: data.product_id,
        prazo: data.prazo,
        preco: data.preco,
      })
    );
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/simulacao`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    });

    return result;
  } catch (error) {
    if (error.response.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      return window.location.replace("/");
    }
    return alert("Algo deu errado, tente novamente mais tarde.");
  }
}

export async function getSimulationById(accessToken, id) {
  try {
    const result = await axios.get(`${BASE_API_URL}/simulacao/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return result.data;
  } catch (error) {
    if (error.response.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      return window.location.replace("/");
    }
    return alert("Algo deu errado, tente novamente mais tarde.");
  }
}

export async function editSimulation(accessToken, data) {
  try {
    const result = await axios(`${BASE_API_URL}/simulacao`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    });

    return result;
  } catch (error) {
    if (error.response.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      return window.location.replace("/");
    }
    return alert("Algo deu errado, tente novamente mais tarde.");
  }
}
